<template>
    <shinsei-detail />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ShinseiDetail from '@/components/shinsei/detail/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'shinsei-detail': ShinseiDetail
    }
})
</script>
